import React from 'react';
import { Button } from '@ihsm/ui-shared';
import type { ButtonProps } from '@ihsm/ui-shared/lib/typings/shared/components/Button/types';

export type BasicButtonProps = Pick<
  ButtonProps,
  'text' | 'onClick' | 'disabled' | 'iconSrc'
>;

export const TransparentButton: React.FC<BasicButtonProps> = ({
  onClick,
  text,
  iconSrc,
  disabled,
}) => (
  <Button
    theme="transparent"
    text={text}
    onClick={onClick}
    iconSrc={iconSrc}
    disabled={disabled}
  />
);

export const SmallTransparentButton: React.FC<BasicButtonProps> = ({
  onClick,
  text,
  iconSrc,
  disabled,
}) => (
  <Button
    theme="transparent"
    size="small"
    text={text}
    onClick={onClick}
    iconSrc={iconSrc}
    disabled={disabled}
  />
);
